import { render } from "./ClaimDecisionModal.vue?vue&type=template&id=39ac95f0"
import script from "./ClaimDecisionModal.vue?vue&type=script&lang=js"
export * from "./ClaimDecisionModal.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./ClaimDecisionModal.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_0bcf977f%2Fpackages%2Fbo%2Fsrc%2Fcomponents%2Fclaim%2Fdetails%2Faction%2FClaimDecisionModal.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__